import Line from "../../components/debrief/tournamentView/Line";

export const TBD = "TBD";

export function getNumberOfMatchesBottomBracket(totalRounds) {
  return Math.round(Math.round(Math.pow(2, totalRounds - 1)) / 2);
}

export function getNumberOfLanes(totalRounds) {
  return Math.round(totalRounds * 2) - 1;
}

export function getFontStyle(
  fontSize,
  boxW,
  boxH,
  forNightMode,
  bold = false,
  won = false
) {
  let fontStyle = {
    position: "absolute",
    width: "fit-content",
    top: boxH / 2 - fontSize / 2,
    left: boxW / 2,
    fontSize: fontSize.toString(10) + "px",
    transform: "translate(-50%, -50%)",
    fontWeight: bold ? "800" : "500",
    textAlign: "center",
    color: "#010101",
    backgroundColor: "transparent",
  };
  if (forNightMode) {
    fontStyle.color = "#c2c4c2";
  }
  if (won) {
    fontStyle.backgroundColor = forNightMode ? "#485138" : "#b5ca8d";
  }
  return fontStyle;
}

export function isThisLaneLeftSide(laneNumber, numberOfLanes) {
  return laneNumber < Math.round(numberOfLanes / 2);
}

export function numberOfMatchesForLane(
  laneNumber,
  totalRounds,
  numberOfMatchesBottomBracket,
  numberOfLanes
) {
  // Note: numberOfMatchesBottomBracket is HALF because of
  // two pyramids

  // is this the center ?
  if ((numberOfLanes + 1) / 2 === laneNumber) {
    return 1;
  }
  const isLeftSide = isThisLaneLeftSide(laneNumber, numberOfLanes);
  const pseudoLane = getPseudoLaneNumber(isLeftSide, laneNumber, totalRounds);
  return numberOfMatchesBottomBracket * Math.pow(2, -(pseudoLane - 1));
}

export function getPseudoLaneNumber(isLeftSide, laneNumber, totalRounds) {
  if (totalRounds % 2 === 0 && (totalRounds + 1) / 2 === laneNumber) {
    return laneNumber;
  } else {
    return isLeftSide ? laneNumber : Math.round(totalRounds * 2) - laneNumber;
  }
}

export function getPseudoMatchNumber(
  isLeftSide,
  index,
  numberOfMatchesInLane,
  numberOfMatchesInRound,
  numberOfRoundsIsOdd
) {
  if (isLeftSide) {
    return index;
  }
  if (numberOfMatchesInRound === 1) {
    return 0;
  }
  const realTotalMatchesForRound = numberOfMatchesInLane * 2;
  return realTotalMatchesForRound - index - 1;
}

export function getCellSizeForLane(sizes, numMatchesForLane) {
  return {
    h: Math.round(sizes.laneH / numMatchesForLane),
    w: sizes.laneW,
  };
}

export function getCellPosition(cellSize, row, lane, xOffset = 0, yOffset = 0) {
  const zeroLane = lane - 1;
  return {
    x: zeroLane * cellSize.w + xOffset,
    y: row * cellSize.h + yOffset,
  };
}

export function getCenteredObjectPosition(cellPos, cellSize, objectW, objectH) {
  return {
    x: cellPos.x + cellSize.w / 2 - objectW / 2,
    y: cellPos.y + cellSize.h / 2 - objectH / 2,
  };
}

export function getEnterAndExitPointsOfMatch(
  originX,
  originY,
  sizes,
  isLeftSide
) {
  if (isLeftSide) {
    return {
      topEnterX: originX,
      topEnterY: originY + sizes.storyBoxH / 2 + sizes.smallPadding,
      bottomEnterX: originX,
      bottomEnterY:
        originY + sizes.matchBoxH - sizes.storyBoxH / 2 - sizes.smallPadding,
      exitX: originX + sizes.matchBoxW,
      exitY:
        originY +
        sizes.storyBoxH +
        sizes.smallPadding * 3 +
        sizes.versusBoxH / 2,
    };
  } else {
    return {
      topEnterX: originX + sizes.matchBoxW,
      topEnterY: originY + sizes.storyBoxH / 2 + sizes.smallPadding,
      bottomEnterX: originX + sizes.matchBoxW,
      bottomEnterY:
        originY + sizes.matchBoxH - sizes.storyBoxH / 2 - sizes.smallPadding,
      exitX: originX,
      exitY:
        originY +
        sizes.storyBoxH +
        sizes.smallPadding * 3 +
        sizes.versusBoxH / 2,
    };
  }
}

export function truncateTitle(text, zoomLevel) {
  // TODO: make this contigent on levels
  if (!text) {
    return "";
  }
  let maxChar = 35;
  if (zoomLevel === 1) {
    maxChar = 35;
  }
  // TODO: make this contigent on levels
  return text.slice(0, maxChar) + (text.length > maxChar ? "..." : "");
}

export function getPositionOfStoriesInMatchBox(
  matchPos,
  storyHeight,
  versusHeight,
  padding
) {
  const topY = matchPos.y + padding;
  const versusY = topY + storyHeight + padding;
  const bottomY = versusY + versusHeight + padding;
  const x = matchPos.x + padding;
  return {
    topX: x,
    topY,
    versusX: x,
    versusY,
    bottomX: x,
    bottomY,
  };
}

export function hasNaN(obj) {
  let hasNan = false;
  for (const [key, value] of Object.entries(obj)) {
    if (isNaN(value) && typeof value === "number") {
      console.log(`Property '${key}' is NaN`);
      hasNan = true;
    }
  }
  return hasNan;
}

export function createLinesToNextMatch(
  matchPosA,
  matchPosB,
  sizes,
  payload,
  isLeftSide,
  toTop,
  nightMode
) {
  const enterExitPointsA = getEnterAndExitPointsOfMatch(
    matchPosA.x,
    matchPosA.y,
    sizes,
    isLeftSide
  );
  const enterExitPointsB = getEnterAndExitPointsOfMatch(
    matchPosB.x,
    matchPosB.y,
    sizes,
    isLeftSide
  );

  // Exit Line
  payload.push(
    <Line
      key={
        "exit_" +
        enterExitPointsA.exitX.toString() +
        "_" +
        enterExitPointsA.exitY.toString() +
        "_" +
        (enterExitPointsA.exitX + sizes.normalSpace).toString() +
        "_" +
        enterExitPointsA.exitX.toString()
      }
      pointA={{ x: enterExitPointsA.exitX, y: enterExitPointsA.exitY }}
      pointB={{
        x:
          enterExitPointsA.exitX +
          (isLeftSide ? sizes.normalSpace : -sizes.normalSpace),
        y: enterExitPointsA.exitY,
      }}
      nightMode={nightMode}
    />
  );

  // Enter Line
  payload.push(
    <Line
      key={
        "enter_" +
        (
          (toTop ? enterExitPointsB.topEnterX : enterExitPointsB.bottomEnterX) -
          sizes.normalSpace
        ).toString() +
        "_" +
        (toTop
          ? enterExitPointsB.topEnterY
          : enterExitPointsB.bottomEnterY
        ).toString() +
        "_" +
        (toTop
          ? enterExitPointsB.topEnterY
          : enterExitPointsB.bottomEnterY
        ).toString() +
        "_" +
        (toTop
          ? enterExitPointsB.topEnterY
          : enterExitPointsB.bottomEnterY
        ).toString()
      }
      pointA={{
        x:
          (toTop ? enterExitPointsB.topEnterX : enterExitPointsB.bottomEnterX) -
          (isLeftSide ? sizes.normalSpace : -sizes.normalSpace),
        y: toTop ? enterExitPointsB.topEnterY : enterExitPointsB.bottomEnterY,
      }}
      pointB={{
        x: toTop ? enterExitPointsB.topEnterX : enterExitPointsB.topEnterX,
        y: toTop ? enterExitPointsB.topEnterY : enterExitPointsB.bottomEnterY,
      }}
      nightMode={nightMode}
    />
  );

  // Connector Line -- exit to enter
  payload.push(
    <Line
      key={
        "connector_" +
        (enterExitPointsA.exitX + sizes.normalSpace).toString() +
        "_" +
        enterExitPointsA.exitY.toString() +
        "_" +
        (
          (toTop ? enterExitPointsB.topEnterX : enterExitPointsB.bottomEnterX) -
          sizes.normalSpace
        ).toString() +
        "_" +
        (toTop
          ? enterExitPointsB.topEnterY
          : enterExitPointsB.bottomEnterY
        ).toString()
      }
      pointA={{
        x:
          enterExitPointsA.exitX +
          (isLeftSide ? sizes.normalSpace : -sizes.normalSpace),
        y: enterExitPointsA.exitY,
      }}
      pointB={{
        x:
          enterExitPointsA.exitX +
          (isLeftSide ? sizes.normalSpace : -sizes.normalSpace),
        y: toTop ? enterExitPointsB.topEnterY : enterExitPointsB.bottomEnterY,
      }}
      nightMode={nightMode}
    />
  );
}

export function getSizesForZoomLevel(level, totalRounds) {
  // TODO: make different zoom levels
  let matchBoxW = 400;
  let matchBoxH = 200;
  let normalSpace = 50;
  let smallPadding = 10;
  let smallFontSize = 14;
  let normalFontSize = 16;
  let largeFontSize = 20;

  let laneW = matchBoxW + Math.floor(normalSpace * 2);
  const numberOfMatchesBottomBracket =
    getNumberOfMatchesBottomBracket(totalRounds);
  let laneH = Math.ceil(
    (matchBoxH + normalSpace) * numberOfMatchesBottomBracket
  );

  let numberOfLanes = getNumberOfLanes(totalRounds);
  let screenSizeW = laneW * numberOfLanes;
  let screenSizeH = laneH;
  let storyBoxH = Math.floor(matchBoxH * 0.4) - smallPadding * 2;
  let storyBoxW = matchBoxW - smallPadding * 2;
  let versusBoxH = Math.floor(matchBoxH * 0.2);

  let storyCellW = Math.floor(storyBoxW * 0.2);

  let flagW = 40;

  // Fonts

  return {
    matchBoxW,
    matchBoxH,
    normalSpace,
    laneW,
    laneH,
    totalRounds,
    numberOfLanes,
    screenSizeW,
    screenSizeH,
    smallPadding,
    storyBoxW,
    storyBoxH,
    versusBoxH,
    storyCellW,
    smallFontSize,
    normalFontSize,
    largeFontSize,
    numberOfMatchesBottomBracket,
    flagW,
  };
}
